<template>
  <div>
    <Layout/>
    <h4>Tipo de Examen</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTipoExamen" class="form-label">IdTipoExamen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTipoExamen" name="idTipoExamen" v-model="datoTipoExamen.idTipoExamen" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoTipoExamen.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarTipoExamen" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTipoExamen" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdExamen</th>
          <th scope="col">IdTipoExamen</th>
          <th scope="col">Nombre</th>
          <th scope="col">Estado</th>
          <th scope="col">TipoExamenNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="examen in datosPaginados" :key="examen.idExamen">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(examen.idExamen)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(examen.idExamen)" title="Editar">edit_square</i></td>
          <td>{{examen.idExamen}}</td>
          <td>{{examen.idTipoExamen}}</td>
          <td>{{examen.nombre}}</td>
          <td>{{examen.estado}}</td>
          <td>{{examen.tipoExamenNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTipoExamen(examen.idExamen)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idExamen" class="form-label">IdExamen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamen" name="idExamen" v-model="datoExamen.idExamen" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTipoExamen" class="form-label">IdTipoExamen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTipoExamen" name="idTipoExamen" v-model="datoExamen.idTipoExamen" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoExamen.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarExamen" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExamen" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      tipoexamens : [],
      datoTipoExamen : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idTipoExamen: '',
// Variables master
// Variables details
      examens : [],
      datoExamen : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      tipoExamens : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idTipoExamen = this.$route.params.p_idtipoexamen
    this.abrirEditar(this.p_idTipoExamen)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoTipoExamen, requiredFields, requiredFieldsText);
    },
    async guardarTipoExamen(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tipoexamens', this.datoTipoExamen)
          swal("Correcto!", "TipoExamen creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTipoExamen(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tipoexamens', this.datoTipoExamen)
          swal("Correcto!", "TipoExamen creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoTipoExamen={}
      this.titulo   = 'Crear Tipo de Examen'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idTipoExamen){
      this.modalWindow = true
      if(idTipoExamen != null){    
           api.get('/vwtipoexamens/'+idTipoExamen).then(resp=>{
          this.datoTipoExamen = resp.data;
           });
      }
      this.titulo   = 'Editar Tipo de Examen'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarTipoExamen(){
      this.$router.push('/TipoExamen')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.examens.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwexamens/nombre/'+this.nombreBusqueda).then(response=>{
          this.examens=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.examens.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwexamens').then(response=>{
      this.examens=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.examens.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoTipoExamen, requiredFields, requiredFieldsText);
    },
    async guardarExamen(){
      if(this.validarForm() === 1){
        try {
          this.datoExamen.idTipoExamen = this.datoTipoExamen.idTipoExamen;
          await api.post('/examens', this.datoExamen)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Examen creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExamen(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examens', this.datoExamen)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Examen creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoExamen={}
      this.titulo   = 'Crear Tipo de Examen'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idExamen){
      this.modalWindow = true
      if(idExamen != null){    
           api.get('/vwexamens/'+idExamen).then(resp=>{
          this.datoExamen = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Tipo de Examen'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idExamen){
      this.modalWindow = true
      if(idExamen != null){
        this.$router.push('/examenmd/'+idExamen)
      }
    },
    async deleteExamen (idExamen) {
      try{
        await api.delete('/examens/'+idExamen)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchTipoExamens() {
      fetch('http://localhost:8080/api/v1/tipoexamens')
        .then(response => response.json())
        .then(data => {
          this.tipoExamens = data;
        })
        .catch(error => {
          console.error('Error fetching tipoExamens:', error);
        });
    },
  },
}
</script>
